var map = {
	"./01.svg": 48055,
	"./02.svg": 4932,
	"./03.svg": 59653,
	"./04.svg": 48026,
	"./05.svg": 67083,
	"./06.svg": 28248,
	"./07.svg": 63113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51548;